import backend, {CAREGIVER_API, CAREGIVER_ONBOARDING_API} from 'utils/backend/server/api_library';

const getCaregiver = (caregiverRn, recommendationId) => {
  let url = `${CAREGIVER_API}/public/caregiver/${caregiverRn}`;
  if (recommendationId) {
    url = url + `?recommendation=${recommendationId}`;
  }
  return backend.get(url);
};

const createCaregiverFromResume = (resumeText) => {
  const body = {
    resumeText: resumeText,
  };
  const url = `${CAREGIVER_ONBOARDING_API}/resume/resume_handler`;
  return backend.post(url, body);
};

const createCaregiverFromForm = (formData) => {
  const url = `${CAREGIVER_ONBOARDING_API}/caregiver_onboarding_survey/onboarding_survey`;
  return backend.post(url, formData);
};

export default {
  getCaregiver,
  createCaregiverFromResume,
  createCaregiverFromForm,
};
